// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2W7sS","label":"styles_label__3fAdx"};